import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
// Make sure to import your CSS file, e.g., import './RatingAnswerTips.css';

const tips = [
    {
        title: 'review_tips.stay_professional.title',
        description: 'review_tips.stay_professional.description',
    },
    {
        title: 'review_tips.short_and_simple.title',
        description: 'review_tips.short_and_simple.description',
    },
    {
        title: 'review_tips.answer_on_demand.title',
        description: 'review_tips.answer_on_demand.description',
    },
    {
        title: 'review_tips.friend_not_sales.title',
        description: 'review_tips.friend_not_sales.description',
    },
];

const negative_review = [
    {
        title: 'negative_review_tips.no_personal_infos.title',
        description: 'negative_review_tips.no_personal_infos.description',
    },
    {
        title: 'negative_review_tips.research_why.title',
        description: 'negative_review_tips.research_why.description',
    },
    {
        title: 'negative_review_tips.be_honest.title',
        description: 'negative_review_tips.be_honest.description',
    },
    {
        title: 'negative_review_tips.excuse.title',
        description: 'negative_review_tips.excuse.description',
    },
    {
        title: 'negative_review_tips.fast_reply.title',
        description: 'negative_review_tips.fast_reply.description',
    },
];

class RatingAnswerTips extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            expandedIndex: undefined,
        };
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <label style={{ marginBottom: 10 }}>{t('review_tips.title')}</label>
                <div className="answer-tips-container">
                    {tips.map((tip, index) => {
                        const isExpanded = this.state.expandedIndex === index;
                        return (
                            <div
                                className={`card-accordion ${isExpanded ? 'expanded' : ''}`}
                                key={index}
                                onClick={() => this.setState({ expandedIndex: isExpanded ? undefined : index })}>
                                <div className="module-title">
                                    <h4>{t(tip.title)}</h4>
                                    <span className={`arrow-icon ${isExpanded ? 'rotated' : ''}`}>&#9660;</span>
                                </div>
                                <div className={`content-wrapper ${isExpanded ? 'show-content' : ''}`}>
                                    <p>{t(tip.description)}</p>
                                </div>
                            </div>
                        );
                    })}
                    {this.props.lowestRating < 3.5 && (
                        <>
                            <div style={{ marginBottom: 10 }}>
                                <label>{t('review_tips.title_below_average')}</label>
                            </div>

                            {negative_review.map((tip, index) => {
                                const isExpanded = this.state.expandedIndex === index;
                                return (
                                    <div
                                        className={`card-accordion ${isExpanded ? 'expanded' : ''}`}
                                        key={index}
                                        onClick={() =>
                                            this.setState({ expandedIndex: isExpanded ? undefined : index })
                                        }>
                                        <div className="module-title">
                                            <h4>{t(tip.title)}</h4>
                                            <span className={`arrow-icon ${isExpanded ? 'rotated' : ''}`}>&#9660;</span>
                                        </div>
                                        <div className={`content-wrapper ${isExpanded ? 'show-content' : ''}`}>
                                            <p>{t(tip.description)}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default RatingAnswerTips;
